<div class="search-wrapper" [class.active]="isActive" style="margin-left: 30%;" >
  <div class="input-holder" style="background-color: whitesmoke ; border-radius: 100px;height:30px ;margin-top:5px ;" >
    <input type="text"
           placeholder="Search for a reservation"
           [(ngModel)]="key"
           (ngModelChange)="filter()"
           [matAutocomplete]="auto"
           class="search-input">
    <mat-autocomplete #auto="matAutocomplete" class="mt-2 shadow-lg">
      <perfect-scrollbar>
      <mat-option *ngFor="let reservation of result" style="background-color: rgba(237,238,239,0.55)">
        <div class="m-auto" style="width:100%">
          <ul>
            <li class="pl-2 pr-3" style="width: 20px">
              <i  aria-hidden="true" style="font-size: 20px" class="fa mr-1 font-weight-bolder" [ngClass]="{'pe-7s-bottom-arrow text-info': reservation.state == 'in-house',
                            'pe-7s-left-arrow text-danger fa-flip-horizontal' : reservation.state == 'check-out',
                            'fa-calendar text-warning fa-flip-horizontal' : reservation.state == 'reserved',
                            'pe-7s-right-arrow text-success' : reservation.state == 'check-in'}"></i></li>
            <li class="font-weight-light">#<small>{{reservation.id}}</small></li>
            <li class="font-weight-light"><small>{{reservation.guestName}} </small></li>
            <li class="font-weight-light"><small>{{reservation.class}} </small></li>
            <li class="font-weight-light"><small>{{reservation.roomtype}} </small></li>
            <li class="font-weight-light"> <div class="mb-2 mr-2 badge"  [ngClass]="{'badge-info': reservation.state == 'in-house',
                            'badge-danger' : reservation.state == 'check-out',
                            'badge-warning' : reservation.state == 'reserved',
                            'badge-success' : reservation.state == 'check-in'}">
              <small> {{reservation.state}} </small>
            </div> </li>
            <li class="font-weight-light"><small>{{reservation.start}} </small></li>
            <li class="font-weight-light"><i class="fa fa-arrow-right"></i></li>
            <li class="font-weight-light"><small>{{reservation.finish}} </small></li>
          </ul>
        </div>
      </mat-option>
      </perfect-scrollbar>
    </mat-autocomplete>
    <button class="search-icon" (click)="isActive = true" style="background-color: whitesmoke;color: whitesmoke;height:30px"><span></span></button>
  </div>
  <button class="close" (click)="isActive = false"></button>
</div>

